module.exports = __webpack_public_path__ + "img/nav-appointment@2x.ed9edd6.jpg";